<template>
  <div @click="linkManual()" class="manual">
    {{ $l.manual }}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  methods: {
    linkManual: function () {
      window.open(this.$l.urlManual, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.manual {
  color: red;
  &:hover {
    cursor: pointer;
  }
}
</style>
